import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { ListaItem } from "../../_models/lista-item";
import { SelectItem } from "primeng/api";
import { Router } from "@angular/router";
import { ListaService } from "../../_services/lista.service";
import { ConstanteService } from "../../_services/constante.service";
import { forkJoin } from "rxjs";
import { InformacionTerceroDTO } from "../../_models/perfil-cliente/informacionTercero";
import { AdjuntoService } from "../../_services/adjunto.service";
import { Funcionalidad } from "../../_models/funcionalidad";
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TerceroLocalizacionesService } from '../../_services/tercero-localizaciones.service';
import { Localizaciones } from '../../_models/localizaciones';
import { GestionComercialPreaprobadoComponent } from "../../PYS/gestion-comercial/gestion-comercial-preaprobado/gestion-comercial-preaprobado.component";
import { PreAprobadosService } from '../../_services/pre-aprobados.service';
import {PreAprobadosOfertasService} from '../../_services/pre-aprobados-ofertas.service';

@Component({
  selector: "app-perfil-crezcamos-general",
  templateUrl: "./perfil-crezcamos-general.component.html",
  styleUrls: ["./perfil-crezcamos-general.component.scss"],
})
export class PerfilCrezcamosGeneralComponent implements OnInit {
  cargaInicial = true;
  seccion = "buscador";
  tabSeleccionado = "";
  lisTiposDocumentosTodos: ListaItem[] = [];
  lisTiposDocumentos: SelectItem[] = [];
  informacion: any = {};
  errorConsultaCliente: boolean = false;
  informacionTercero: InformacionTerceroDTO;
  imagenUrl: string;
  esImagen: boolean = true;
  cargandoPdf: boolean = false;
  permisoSimulado: boolean = false;
  private menu: Funcionalidad[] = [];
  localizaciones: Localizaciones[] = [];
  localizacion: Localizaciones;
  locaclizacionHogar: Localizaciones;
  locaclizacionNegocio: Localizaciones;
  mostrarDialogoLocalizaciones: boolean = false;
  maximaFechaPreaprobado: string = null;

  infoPerfilCrezcamos: any;

  constructor(
    private router: Router,
    private listaService: ListaService,
    private consServicio: ConstanteService,
    private adjService: AdjuntoService,
    private ref: DynamicDialogRef,
    private terceroLocalizacionesService: TerceroLocalizacionesService,
    private diaService: DialogService,
    private preAprobadosService: PreAprobadosService,
    private preAprobadosOfertasService: PreAprobadosOfertasService,
  ) {}

  async ngOnInit() {
    this.cargarInformacionInicial();
    this.permisoSimulado = await this.validarPermiso()
  }

  async cargarInformacionInicial() {
    try {
      const [docMayorEdad, lisTiposDocumentos] = await forkJoin([
        this.consServicio.getByCode("DOCMYE"),
        this.listaService.getMasterDetails("ListasTiposDocumentos"),
      ]).toPromise();

      const listaDocumentos = docMayorEdad?.valor?.split(",") || [];

      this.lisTiposDocumentosTodos = lisTiposDocumentos.filter((x) =>
        listaDocumentos.includes(x.codigo)
      );
      this.lisTiposDocumentos = this.lisTiposDocumentosTodos.map(
        (s: ListaItem) => ({ label: s.nombre, value: s.codigo })
      );


    } catch (error) {
      console.error("Error loading initial data", error);
    } finally {
      this.cargaInicial = false;
    }
  }

  async obtenerInformacionTercero(data: any) {
    this.cargaInicial = true;

    try {
    this.informacion = data ? data : null;
    this.seccion = "informacion";

    this.informacionTercero = this.informacion && this.informacion.informacionTerceroDTO ? this.informacion.informacionTerceroDTO : null;

    this.localizacionesTercero(this.informacionTercero);

    this.tabSeleccionado = this.setTabSeleccionado(this.informacion.secciones);

    if (this.informacion.numeroDocumento && this.informacion.codigoTipoDocumento) {
      await this.cargarListadoPreaprobado();
      await this.preAprobadosService
        .maximaFechaPreaprobado(this.informacion.numeroDocumento, this.informacion.codigoTipoDocumento)
        .subscribe({ next: (fecha) => this.maximaFechaPreaprobado = fecha, error: () => this.maximaFechaPreaprobado = null });
    }
    this.cargaInicial = false;

    } catch (error) {
      console.error(error);
      this.cargaInicial = false;
    }
  }

  async cargarListadoPreaprobado(){
      const res = await this.preAprobadosOfertasService.obtenerInformePreaprobado(this.informacion.codigoTipoDocumento, this.informacion.numeroDocumento).toPromise();
      console.log( res );
      this.infoPerfilCrezcamos = (res && res.length > 0) ? res : null;
  }

  localizacionesTercero(informacion) {
    if(!informacion || !this.informacion) {
      this.localizaciones = [];
      this.locaclizacionHogar = null;
      this.locaclizacionNegocio = null;
      return;
    }
    this.terceroLocalizacionesService.getAllByEmployee( this.informacion.idTercero ).subscribe( employeesLocations => {
      this.localizaciones = employeesLocations.filter( x => x.indicadorHabilitado );
      console.log(this.localizaciones)
      this.locaclizacionHogar = this.localizaciones.find( x => x.direccion === informacion.direccionHogar );
      this.locaclizacionNegocio = this.localizaciones.find( x => x.direccion === informacion.direccionNegocio );
    } );
  }

  errorConsulta(data: any) {

    this.errorConsultaCliente = data;
  }

  // cambiarTab(event: any) {
  //
  //   if (event &&event.detail.value) {
  //     this.tabSeleccionado = event.detail.value;
  //   }
  // }

  setTabSeleccionado(array) {
    const prioridades = ["PERCRZ", "HISCRE", "SOLVIG", "CLITEL"];

    for (const prioridad of prioridades) {
      if (array.includes(prioridad)) {
        return prioridad;
      }
    }
    return null;
  }

  volver() {
    if (this.seccion === 'informacion' || this.errorConsultaCliente) {
      this.errorConsultaCliente = false;
      this.seccion = "buscador"
      this.tabSeleccionado = "PERFILCREZCAMOS"
    } else {
      this.router.navigate(["/dashboard"]);
    }
  }

  redireccionar(url: string = "") {
    if (url) {
      this.router.navigate([url], { replaceUrl: true });
    }
  }

  async validarPermiso() {
    const funcionalidades = this.obtenerMenus();
    const validacion = this.findItemWithCodeAndChild(
      funcionalidades,
      "MODHER",
      "SIMCRE"
    );

    return validacion;
  }

  obtenerMenus() {
    const menus = localStorage.getItem("menu");
    if (menus !== null) {
      this.menu = JSON.parse(menus);
    } else {
      this.menu = [];
    }
    return this.menu;
  }

  findItemWithCodeAndChild(items, parentCode, childCode) {
    // Función auxiliar para buscar recursivamente en los hijos
    function findChild(item, childCode) {
      if (!item.hijos) return false;
      return item.hijos.some((hijo) => hijo.codigo === childCode);
    }

    // Recorrer el array principal
    for (let item of items) {
      if (item.codigo === parentCode && findChild(item, childCode)) {
        return true;
      }
    }
    return false;
  }

  async crearSolicitud() {
    const PerfilCrezcamosData = {
      idTipoDocumento: this.informacion.idTipoDocumento,
      numeroDocumento: this.informacion.numeroDocumento
    };

    if (localStorage.getItem("informacionPerfilCrezcamos")) {
      localStorage.removeItem("informacionPerfilCrezcamos");
    }
    localStorage.setItem(
      `informacionPerfilCrezcamos`,
      JSON.stringify(PerfilCrezcamosData)
    );
    this.router.navigate(["pys/gestion-comercial/flujo-venta-proceso"]);
    this.ref.close();
  }

  async crearSimulacion() {
    this.router.navigate(["/apl/simulador-credito"]);
    this.ref.close();
  }

  regresar() {
    this.cargaInicial = false;
    this.seccion = "buscador";
    this.tabSeleccionado = "";
    // this.lisTiposDocumentosTodos = [];
    // this.lisTiposDocumentos = [];
    this.informacion = {};
    this.errorConsultaCliente = false;
    this.informacionTercero = null;
    this.imagenUrl = "";
    this.esImagen = true;
    this.cargandoPdf = false;
    this.menu = [];
  }

  mostrarLocalizacion(direccionHogar: boolean = false) {
    this.localizacion = direccionHogar ? this.locaclizacionHogar : this.locaclizacionNegocio;
    this.mostrarDialogoLocalizaciones = true;
  }

  cerrarDialogoLocalizaciones() {
    this.mostrarDialogoLocalizaciones = false;
  }

  gestionarAhora() {
    const registroTitular = {
      documento:       this.informacion.numeroDocumento,
      codigoDocumento: this.informacion.codigoTipoDocumento,
      nombreCompleto:  this.informacion.nombre,
    };
    const modal = this.diaService.open(GestionComercialPreaprobadoComponent, {
      showHeader: false,
      width: '75%',
      style: { 'border-radius': '10px 10px 0 0', 'overflow': 'hidden' },
      data: {
        registro: registroTitular,
        esModal: true,
        perfilCrezcamos: true
      }
    });
    modal.onClose.subscribe((data: any) => {
      if (data?.volver) {
        this.tabSeleccionado = 'PERCRZ';
      } else {
        this.ref.close();
      }
    });
  }
}
